import React from "react";
import "../style/Aboutus.css"; 
import factory1 from "../assets/aboutus-images/1.png";
import factory2 from "../assets/aboutus-images/2.png";
import factory3 from "../assets/aboutus-images/3.png";
import factory4 from "../assets/aboutus-images/4.png";
import webbanner from "../assets/banner/webbanner.jpg"
import LeaveMessage from "./LeaveMessage";


const Aboutus = () => {
  return (
    <div>
      <div id="searchResults"></div>
      <LeaveMessage />
 
      <section>
              <img src={webbanner} alt="web-banner" />
      </section>

      
      <section>
        <div className="heading-section">
          <h2>ABOUT US</h2>
        </div>
      </section>

      
      <section>
        <div className="about-details">
         
          
          <p>
           Promoted with the vision to bring global innovation in home automation to Indian households and commercial spaces, A-OK Motors India is a premium distributor of cutting-edge motorized solutions for blinds, curtains, and smart control systems.
Backed by the international expertise of Guangdong A-OK Technology Grand Development Co., Ltd., a pioneer since 1998, our journey in India began in 2016. With a focus on efficiency, simplicity, and elegance, we are reimagining how Indian homes interact with technology.

          </p>

          <p>
            Our products can meet the mandatory requirements for safety
            certification in various countries around the world, and comply with
            CE, TUV, UL, CCC, C-TUV-US, CB, C-TICK, R&TTE, FCC, RoHS and other
            certification requirements.
          </p>
        </div>
      </section>

      {/* About Images */}
      <section>
        <div className="about-img">
            
            <img src={factory1} alt="Factory 1" />
            <img src={factory2} alt="Factory 2" />
            <img src={factory3} alt="Factory 3" />
            <img src={factory4} alt="Factory 4" />
        </div>
      </section>
    </div>
  );
};

export default Aboutus;
